
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34765',
  depVersions: {
  "documents-public-ui": "static-1.34765",
  "atom": "static-1.5180",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2604",
  "client-types": "static-1.479",
  "cssUtils": "static-1.822",
  "customer-data-filters-ui": "static-1.40141",
  "customer-data-objects": "static-1.7785",
  "customer-data-property-utils": "static-1.8201",
  "documents-lib": "static-1.34770",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.345",
  "FormsCommonComponents": "static-1.86111",
  "FormUrlGenerator": "static-2.4827",
  "foundations-theming-specialty": "static-1.2252",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5697",
  "hs-test-utils": "static-1.8124",
  "hub-http": "static-1.6329",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11888",
  "HubStyleTokens": "static-2.11581",
  "I18n": "static-7.1636",
  "icons": "static-2.653",
  "jasmine-immutable": "static-1.3127",
  "jasmine-runner": "static-1.6564",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7258",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5503",
  "quartz": "static-1.7162",
  "react": "static-7.187",
  "react-dlb": "static-1.81",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16788",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5419",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8280",
  "reference-resolvers-lite": "static-1.8204",
  "reporting-data": "static-1.67970",
  "reporting-reports": "static-1.67648",
  "reporting-snowflake": "static-1.56588",
  "reporting-testing-lib": "static-1.9903",
  "reporting-visualizations": "static-1.60046",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.9053",
  "sanitize": "static-1.4582",
  "sanitize-text": "static-1.8251",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1852",
  "signup-constants": "static-1.19085",
  "signup-ui-url-generator": "static-2.8163",
  "StyleGuideUI": "static-3.489",
  "superstore": "static-1.4866",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4866",
  "ui-addon-form-validation": "static-1.11095",
  "ui-asset-management-lib": "static-1.11168",
  "ui-images": "static-2.1179",
  "UIComponents": "static-3.8527",
  "usage-tracker": "static-1.7455",
  "usage-tracker-container": "static-1.7445",
  "usage-tracker-core": "static-1.7305",
  "viral-links-lib": "static-1.7175",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9768",
  "foundations-components": "static-1.8139",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.940",
  "quartz-core": "static-1.6381",
  "quick-fetch": "static-1.3994",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4762",
  "ui-addon-i18n": "static-1.11255",
  "ui-addon-upgrades": "static-9.18139",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3475",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3439",
  "quartz-webpack": "static-1.3386",
  "foundations-assets": "static-1.4979",
  "foundations-theming": "static-1.4536",
  "hub-http-shared-msw-handlers": "static-1.10218",
  "hubspotter-http": "static-1.4728",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7354",
  "crm-message-bus": "static-1.43247",
  "customer-data-filters-ui-msw-helpers": "static-1.22576",
  "customer-data-objects-ui-components": "static-1.13137",
  "customer-data-reference-ui-components": "static-1.13278",
  "customer-data-ui-utilities": "static-1.9931",
  "events-data-lib": "static-1.338",
  "framework-builder-read-service-client": "static-1.4081",
  "framework-data-schema-quick-fetch": "static-1.6903",
  "framework-data-schema-resolvers": "static-1.6998",
  "inbound-db-meta-service-client": "static-1.3663",
  "inbound-db-properties-service-client": "static-1.3922",
  "multi-account-reference-resolvers": "static-1.1088",
  "onboarding-tours": "static-1.16797",
  "reporting-datasets-permissions-lib": "static-1.13974",
  "ui-addon-teams": "static-1.21688",
  "quartz-auth": "static-1.837",
  "ui-business-units-lib": "static-1.9168",
  "usage-tracker-session-replay": "static-1.5141",
  "ai-components-ui-library": "static-1.9212",
  "ContentUtils": "static-1.68657",
  "customer-data-properties": "static-1.51931",
  "forms-ai-lib": "static-1.4483",
  "forms-utils-lib": "static-1.12779",
  "foundations-components-test-utils": "static-1.5622",
  "react-dnd-compat": "static-1.4721",
  "react-tinymce": "static-1.55515",
  "tinymce-config": "static-2.54641",
  "ui-gdpr-components": "static-1.10457",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3521",
  "HeadJS": "static-2.767",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3235",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.159",
  "ui-fonts": "static-1.843",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4432",
  "csstype": "static-1.50",
  "quartz-head": "static-1.827",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1648",
  "external-options-client-types": "static-1.4206",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.837",
  "frontend-preferences-client": "static-1.8034",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "persist-promise": "static-1.3805",
  "reporting-client-types": "static-1.2564",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25680",
  "hubspot-apollo-client": "static-1.4984",
  "foundations-components-legacy": "static-1.1164",
  "quartz-routing": "static-1.592",
  "hs-story-utils": "static-1.9528",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.329",
  "timezone-utils": "static-2.5349",
  "seat-types-lib": "static-1.253",
  "react-create-root-preference": "static-1.34",
  "bend-plugin-foundations-components": "static-1.4408",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2182",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.843",
  "mobile-manifest-mixins": "static-1.542",
  "module-federation": "static-1.27",
  "quartz-test": "static-1.837",
  "quartz-tracking": "static-1.541",
  "trellis-components": "static-1.2201",
  "bend-plugin-chirp-manifest": "static-1.172",
  "chirp-fetch": "static-1.1993",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6075",
  "salesImages": "static-1.527",
  "ts-schema": "static-1.4157",
  "bender-build-tools": "static-1.3281",
  "bend-plugin-foundations-theming": "static-1.3019",
  "stylex": "static-1.34",
  "restore-request-side-panel-lib": "static-1.1139",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.279",
  "pulse": "static-1.702",
  "conditional-properties-service-client": "static-1.3873",
  "crm-pipelines-api-client-types": "static-1.4215",
  "fdsr-migration-layer": "static-1.117",
  "multi-currency-client-types": "static-1.3767",
  "getting-started-shared-tasks": "static-1.18699",
  "growth-data-modal": "static-1.5595",
  "growth-onboarding-confetti": "static-1.3171",
  "growth-onboarding-next-action-utils": "static-1.2220",
  "navigation-components": "static-1.18270",
  "onboarding-tours-client": "static-1.5011",
  "onboarding-tours-utils": "static-1.863",
  "ui-shepherd-react": "static-3.10333",
  "ui-shepherd-tracker": "static-1.7714",
  "ui-universal-auth": "static-1.9104",
  "user-context": "static-1.5216",
  "hubspotter-http-shared-msw-handlers": "static-1.10216",
  "magpie-lib": "static-1.5621",
  "navigation-messaging": "static-1.7597",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21790",
  "copilot-toolkit": "static-1.11400",
  "cms-field-types": "static-1.4920",
  "content-icons-ui": "static-1.2256",
  "integrations-lib": "static-1.16489",
  "calling-global-api": "static-1.64866",
  "calling-internal-common": "static-1.31416",
  "calling-lifecycle-internal": "static-1.66248",
  "calling-lifecycle-messages": "static-1.58542",
  "commerce-products-lib": "static-1.9933",
  "crm-links": "static-1.6414",
  "customer-data-properties-shared-msw-handlers": "static-1.9545",
  "file-manager-components": "static-1.23904",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4294",
  "meetings-icalendar-utils-lib": "static-1.740",
  "object-builder-ui-client": "static-1.49099",
  "pipeline-validation-client-types": "static-1.4043",
  "property-value-citations": "static-1.2545",
  "smart-property-lib": "static-1.7742",
  "tiered-pricing": "static-1.1482",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9170",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20013",
  "tinymce-themes": "static-1.56611",
  "data-token-picker": "static-1.16592",
  "hub-http-contrib": "static-1.3149",
  "interframe": "static-3.4866",
  "tinymce-data": "static-1.40726",
  "tinymce-plugins": "static-1.57755",
  "ui-addon-sales-email": "static-1.5316",
  "onboarding-scopes": "static-1.6567",
  "ui-addon-opt": "static-4.8467",
  "apollo-link-hub-http": "static-2.4758",
  "hubspot-apollo-cache": "static-1.443",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.278",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1047",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6078",
  "event-emitter": "static-1.1056",
  "bend-plugin-pulse": "static-1.205",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2140",
  "growth-onboarding-next-action-components": "static-1.2248",
  "user-context-client": "static-1.4687",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5081",
  "nest": "static-1.338",
  "reactive-lib": "static-1.831",
  "simple-logging-lib": "static-1.3156",
  "unified-auth-core-lib": "static-1.900",
  "getting-started-shared-tasks-store": "static-1.17817",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1077",
  "integrations-error-boundary-lib": "static-1.13904",
  "integrations-tracking-lib": "static-1.5712",
  "native-integrations-shared-strings": "static-1.7889",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10468",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.618",
  "calling-error-reporting": "static-1.31423",
  "shared-worker-versioning": "static-1.11141",
  "calling-usage-tracker": "static-1.6649",
  "voice-sms-access-library": "static-1.1402",
  "customer-data-tracking": "static-1.6995",
  "commerce-permissions": "static-1.883",
  "products-iframe-lib": "static-1.8220",
  "products-ui-components-shared-msw-handlers": "static-1.10600",
  "location-customization-utils-lib": "static-1.9562",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4257",
  "video-components-external": "static-1.11613",
  "video-data-lib": "static-1.35271",
  "data-agent-kit": "static-1.365",
  "feedback-loader": "static-1.29491",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10301",
  "fsm": "static-1.3835",
  "policy-lib": "static-1.6888",
  "react-colorpicker": "static-2.10314",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10364",
  "FileManagerLib": "static-1.39544",
  "NamespacedHubStyle": "static-2.9133",
  "FileManagerCore": "static-1.39403",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7920",
  "layout-dnd-components": "static-1.12646",
  "layout-dnd-utils": "static-1.11621",
  "react-codemirror": "static-1.10733",
  "ui-addon-emoji-picker": "static-1.9993",
  "ui-brand-identity-lib": "static-1.15648",
  "InboxConnectUtils": "static-4.15083",
  "meetings-connect-utils-lib": "static-1.7710",
  "breeze-engine-core": "static-1.355",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3124",
  "ads-unified-auth-lib": "static-1.335",
  "google-sheets-integration-lib": "static-1.540",
  "microsoft-drive-integration-lib": "static-1.675",
  "slack-ui-library": "static-1.10501",
  "calling-orchestration-schema": "static-1.36179",
  "sales-views-client-types": "static-1.4362",
  "crm-record-cards-service-types": "static-1.3666",
  "content-media-composition-data-lib": "static-1.12639",
  "content-media-compositions": "static-2.16646",
  "media-bridge-lib": "static-1.19108",
  "trellis-story-utils": "static-1.4618",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6077",
  "FileManagerImages": "static-1.37055",
  "video-components": "static-1.13615",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4642",
  "video-embed": "static-1.36105",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8809",
  "ui-coaching-tips": "static-1.28848",
  "ContentData": "static-1.68732",
  "layout-data-lib": "static-1.9946",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22323",
  "outpost": "static-1.4276",
  "growth-onboarding-feedback-components": "static-1.6685",
  "advanced-menus-core": "static-1.15297",
  "advanced-menus-lib": "static-1.12211",
  "ExportDialog": "static-6.10486",
  "ui-memberships-settings-lib": "static-1.34323",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15296",
  "simple-menus-lib": "static-1.16813"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34765",
  "atom": "/atom/static-1.5180",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2604",
  "client-types": "/client-types/static-1.479",
  "cssUtils": "/cssUtils/static-1.822",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40141",
  "customer-data-objects": "/customer-data-objects/static-1.7785",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8201",
  "documents-lib": "/documents-lib/static-1.34770",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.345",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86111",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4827",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2252",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5697",
  "hs-test-utils": "/hs-test-utils/static-1.8124",
  "hub-http": "/hub-http/static-1.6329",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11888",
  "HubStyleTokens": "/HubStyleTokens/static-2.11581",
  "I18n": "/I18n/static-7.1636",
  "icons": "/icons/static-2.653",
  "jasmine-immutable": "/jasmine-immutable/static-1.3127",
  "jasmine-runner": "/jasmine-runner/static-1.6564",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7258",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5503",
  "quartz": "/quartz/static-1.7162",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16788",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5419",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8280",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8204",
  "reporting-data": "/reporting-data/static-1.67970",
  "reporting-reports": "/reporting-reports/static-1.67648",
  "reporting-snowflake": "/reporting-snowflake/static-1.56588",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9903",
  "reporting-visualizations": "/reporting-visualizations/static-1.60046",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9053",
  "sanitize": "/sanitize/static-1.4582",
  "sanitize-text": "/sanitize-text/static-1.8251",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1852",
  "signup-constants": "/signup-constants/static-1.19085",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8163",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "superstore": "/superstore/static-1.4866",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4866",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11095",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11168",
  "ui-images": "/ui-images/static-2.1179",
  "UIComponents": "/UIComponents/static-3.8527",
  "usage-tracker": "/usage-tracker/static-1.7455",
  "usage-tracker-container": "/usage-tracker-container/static-1.7445",
  "usage-tracker-core": "/usage-tracker-core/static-1.7305",
  "viral-links-lib": "/viral-links-lib/static-1.7175",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9768",
  "foundations-components": "/foundations-components/static-1.8139",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.940",
  "quartz-core": "/quartz-core/static-1.6381",
  "quick-fetch": "/quick-fetch/static-1.3994",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4762",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11255",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18139",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3475",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3439",
  "quartz-webpack": "/quartz-webpack/static-1.3386",
  "foundations-assets": "/foundations-assets/static-1.4979",
  "foundations-theming": "/foundations-theming/static-1.4536",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10218",
  "hubspotter-http": "/hubspotter-http/static-1.4728",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7354",
  "crm-message-bus": "/crm-message-bus/static-1.43247",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22576",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13137",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13278",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9931",
  "events-data-lib": "/events-data-lib/static-1.338",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4081",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6903",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6998",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3663",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3922",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1088",
  "onboarding-tours": "/onboarding-tours/static-1.16797",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13974",
  "ui-addon-teams": "/ui-addon-teams/static-1.21688",
  "quartz-auth": "/quartz-auth/static-1.837",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9168",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5141",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9212",
  "ContentUtils": "/ContentUtils/static-1.68657",
  "customer-data-properties": "/customer-data-properties/static-1.51931",
  "forms-ai-lib": "/forms-ai-lib/static-1.4483",
  "forms-utils-lib": "/forms-utils-lib/static-1.12779",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5622",
  "react-dnd-compat": "/react-dnd-compat/static-1.4721",
  "react-tinymce": "/react-tinymce/static-1.55515",
  "tinymce-config": "/tinymce-config/static-2.54641",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10457",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3521",
  "HeadJS": "/HeadJS/static-2.767",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3235",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.159",
  "ui-fonts": "/ui-fonts/static-1.843",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4432",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.827",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1648",
  "external-options-client-types": "/external-options-client-types/static-1.4206",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.837",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8034",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3805",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25680",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4984",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1164",
  "quartz-routing": "/quartz-routing/static-1.592",
  "hs-story-utils": "/hs-story-utils/static-1.9528",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.329",
  "timezone-utils": "/timezone-utils/static-2.5349",
  "seat-types-lib": "/seat-types-lib/static-1.253",
  "react-create-root-preference": "/react-create-root-preference/static-1.34",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4408",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2182",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.843",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.542",
  "module-federation": "/module-federation/static-1.27",
  "quartz-test": "/quartz-test/static-1.837",
  "quartz-tracking": "/quartz-tracking/static-1.541",
  "trellis-components": "/trellis-components/static-1.2201",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.172",
  "chirp-fetch": "/chirp-fetch/static-1.1993",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6075",
  "salesImages": "/salesImages/static-1.527",
  "ts-schema": "/ts-schema/static-1.4157",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3019",
  "stylex": "/stylex/static-1.34",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1139",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.279",
  "pulse": "/pulse/static-1.702",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3873",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4215",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.117",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3767",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18699",
  "growth-data-modal": "/growth-data-modal/static-1.5595",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3171",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2220",
  "navigation-components": "/navigation-components/static-1.18270",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5011",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.863",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10333",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7714",
  "ui-universal-auth": "/ui-universal-auth/static-1.9104",
  "user-context": "/user-context/static-1.5216",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10216",
  "magpie-lib": "/magpie-lib/static-1.5621",
  "navigation-messaging": "/navigation-messaging/static-1.7597",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21790",
  "copilot-toolkit": "/copilot-toolkit/static-1.11400",
  "cms-field-types": "/cms-field-types/static-1.4920",
  "content-icons-ui": "/content-icons-ui/static-1.2256",
  "integrations-lib": "/integrations-lib/static-1.16489",
  "calling-global-api": "/calling-global-api/static-1.64866",
  "calling-internal-common": "/calling-internal-common/static-1.31416",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66248",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58542",
  "commerce-products-lib": "/commerce-products-lib/static-1.9933",
  "crm-links": "/crm-links/static-1.6414",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9545",
  "file-manager-components": "/file-manager-components/static-1.23904",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4294",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.740",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49099",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4043",
  "property-value-citations": "/property-value-citations/static-1.2545",
  "smart-property-lib": "/smart-property-lib/static-1.7742",
  "tiered-pricing": "/tiered-pricing/static-1.1482",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9170",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20013",
  "tinymce-themes": "/tinymce-themes/static-1.56611",
  "data-token-picker": "/data-token-picker/static-1.16592",
  "hub-http-contrib": "/hub-http-contrib/static-1.3149",
  "interframe": "/interframe/static-3.4866",
  "tinymce-data": "/tinymce-data/static-1.40726",
  "tinymce-plugins": "/tinymce-plugins/static-1.57755",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5316",
  "onboarding-scopes": "/onboarding-scopes/static-1.6567",
  "ui-addon-opt": "/ui-addon-opt/static-4.8467",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4758",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.443",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.278",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1047",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6078",
  "event-emitter": "/event-emitter/static-1.1056",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.205",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2140",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2248",
  "user-context-client": "/user-context-client/static-1.4687",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5081",
  "nest": "/nest/static-1.338",
  "reactive-lib": "/reactive-lib/static-1.831",
  "simple-logging-lib": "/simple-logging-lib/static-1.3156",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.900",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17817",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1077",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13904",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5712",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7889",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10468",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.618",
  "calling-error-reporting": "/calling-error-reporting/static-1.31423",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11141",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6649",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1402",
  "customer-data-tracking": "/customer-data-tracking/static-1.6995",
  "commerce-permissions": "/commerce-permissions/static-1.883",
  "products-iframe-lib": "/products-iframe-lib/static-1.8220",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10600",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9562",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4257",
  "video-components-external": "/video-components-external/static-1.11613",
  "video-data-lib": "/video-data-lib/static-1.35271",
  "data-agent-kit": "/data-agent-kit/static-1.365",
  "feedback-loader": "/feedback-loader/static-1.29491",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10301",
  "fsm": "/fsm/static-1.3835",
  "policy-lib": "/policy-lib/static-1.6888",
  "react-colorpicker": "/react-colorpicker/static-2.10314",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10364",
  "FileManagerLib": "/FileManagerLib/static-1.39544",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9133",
  "FileManagerCore": "/FileManagerCore/static-1.39403",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7920",
  "layout-dnd-components": "/layout-dnd-components/static-1.12646",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11621",
  "react-codemirror": "/react-codemirror/static-1.10733",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9993",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15648",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15083",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7710",
  "breeze-engine-core": "/breeze-engine-core/static-1.355",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3124",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.335",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.540",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.675",
  "slack-ui-library": "/slack-ui-library/static-1.10501",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36179",
  "sales-views-client-types": "/sales-views-client-types/static-1.4362",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3666",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12639",
  "content-media-compositions": "/content-media-compositions/static-2.16646",
  "media-bridge-lib": "/media-bridge-lib/static-1.19108",
  "trellis-story-utils": "/trellis-story-utils/static-1.4618",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6077",
  "FileManagerImages": "/FileManagerImages/static-1.37055",
  "video-components": "/video-components/static-1.13615",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4642",
  "video-embed": "/video-embed/static-1.36105",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8809",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28848",
  "ContentData": "/ContentData/static-1.68732",
  "layout-data-lib": "/layout-data-lib/static-1.9946",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22323",
  "outpost": "/outpost/static-1.4276",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6685",
  "advanced-menus-core": "/advanced-menus-core/static-1.15297",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12211",
  "ExportDialog": "/ExportDialog/static-6.10486",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34323",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15296",
  "simple-menus-lib": "/simple-menus-lib/static-1.16813"
}
};
